import React from 'react'
import styled from 'styled-components'
import { FaRegEdit } from 'react-icons/fa'
import { AiOutlineSave } from 'react-icons/ai'

import { Button } from '../../../buttons'
import { FONTS } from '../../../../constants'
import { getBillingExcludeVat, getBillingVat, getBillingIncludeVat } from '../../../../function/billing'
import { toNumber } from '../../../../function/math'

export const ActionBar = ({
  canEdit,
  isEditList,
  handleClickEditList,
  handleDiscardList,
  handleSave,
  billings,
  projectRevenue,
  projectAvailable,
}) => {
  const billingExcludeVat = getBillingExcludeVat(billings)
  const billingVat = getBillingVat(billings)
  const billingIncludeVat = getBillingIncludeVat(billings)
  return (
    <Root>
      <PriceWrapper>
        <Col>
          <Title>Project Current Price</Title>
          <Number>฿ ​{projectRevenue}</Number>
        </Col>
        <Col>
          <Title>Available</Title>
          <AvailableNumber value={ toNumber(projectAvailable) }>
            ฿​ {projectAvailable}
          </AvailableNumber>
        </Col>
      </PriceWrapper>
      <VatWrapper>
        <Col>
          <Title>Exc. Vat</Title>
          <Number>฿​ {billingExcludeVat}</Number>
        </Col>
        <Col>
          <Title>VAT</Title>
          <Number>฿ ​{billingVat}</Number>
        </Col>
        <Col>
          <Title>Inc. VAT</Title>
          <Number>฿ {billingIncludeVat}</Number>
        </Col>
      </VatWrapper>
      <ButtonWrapper>
        { isEditList &&
        <ButtonGroup>
          <Button
            theme='#28a745'
            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            onClick={ handleSave }
          >
            Save
          </Button>
          <Button
            theme='#6c757d'
            width='70px'
            height='26px'
            onClick={ handleDiscardList }
          >
            Cancel
          </Button>
        </ButtonGroup>
        }
        { !isEditList &&
        <Button
          width='70px'
          height='26px'
          theme='#28a745'
          disabled={ !canEdit }
          onClick={ handleClickEditList }
          icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
        >
          Edit
        </Button>
        }
      </ButtonWrapper>
    </Root>
  )
}

const Root = styled.div`
  height: 58px;
  display: flex;
  flex: 1;
  margin: 12px 24px;
`

const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 2;
  padding: 10px 32px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
`

const VatWrapper = styled(PriceWrapper)`
  flex: 3;
  margin-left: 12px;
  margin: 0 24px;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  flex: 1;
`

const Title = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #C4C4C4;
`

const Number = styled.span`
  font-family: ${FONTS.NOTOSANS_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`

const AvailableNumber = styled(Number)`
  color: ${p => {
    if (p.value > 0) return '#27AE60'
    else if (p.value < 0) return '#D44B49'
    return '#1A1A17'
  }};
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex: 2;
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;

  div:nth-child(1) {
    margin-right: 12px;
  }
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-billing/action-bar.js